module.exports = __webpack_public_path__ + "img/shop.53cbcbf8.svg";